import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { INormPeriodTypeState } from "./types";
import { IIDAStore } from "../types";
import { NormPeriodType } from "../../models/normPeriodTypes";
import { normPeriodService } from "../../services/NormPeriod.service";

export const getInitialState = (): INormPeriodTypeState => {
  return {
    normPeriodTypes: []
  };
};

const namespaced = true;

export const getters: GetterTree<INormPeriodTypeState, IIDAStore> = {
  GetNormPeriods: (state) => {
    return state.normPeriodTypes;
  }
};

export const actions: ActionTree<INormPeriodTypeState, IIDAStore> = {
  reset({ commit }) {
    commit("reset");
  },
  fetchNormPeriods({ commit, state }): Promise<NormPeriodType[]> {
    return new Promise((resolve, reject) => {
      if (state.normPeriodTypes.length === 0) {
        try {
          normPeriodService.fetchNormPeriodTypes().then((normPeriodTypes) => {
            commit("updateNormPeriodTypes", normPeriodTypes);
            return resolve(normPeriodTypes);
          });
        } catch (error) {
          return reject(error);
        }
      } else {
        const normPeriodTypes = state.normPeriodTypes;
        return resolve(normPeriodTypes);
      }
    });
  },
  createNormPeriod({ commit }, normPeriod: NormPeriodType): Promise<NormPeriodType> {
    return new Promise((resolve, reject) => {
      normPeriodService
        .createNormPeriodType(normPeriod)
        .then((newNormPeriod) => {
          commit("insertNormPeriodType", newNormPeriod);
          resolve(newNormPeriod);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateNormPeriod({ commit }, normPeriod: NormPeriodType): Promise<NormPeriodType> {
    return new Promise((resolve, reject) => {
      normPeriodService
        .updateNormPeriodType(normPeriod)
        .then((updatedNormPeriod) => {
          commit("updateNormPeriodType", updatedNormPeriod);
          resolve(updatedNormPeriod);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteNormPeriod({ commit }, normPeriodId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      normPeriodService
        .deleteNormPeriodType(normPeriodId)
        .then((response) => {
          commit("deleteNormPeriodType", normPeriodId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export const mutations: MutationTree<INormPeriodTypeState> = {
  reset(state: INormPeriodTypeState) {
    Object.assign(state, getInitialState());
  },
  insertNormPeriodType(state: INormPeriodTypeState, normPeriod: NormPeriodType) {
    state.normPeriodTypes.push(normPeriod);
  },
  updateNormPeriodType(state: INormPeriodTypeState, normPeriod: NormPeriodType) {
    const index = state.normPeriodTypes.findIndex((d) => d.id === normPeriod.id);
    state.normPeriodTypes.splice(index, 1);
    state.normPeriodTypes.push(normPeriod);
  },
  deleteNormPeriodType(state: INormPeriodTypeState, normPeriodId: number) {
    const index = state.normPeriodTypes.findIndex((d) => d.id === normPeriodId);
    state.normPeriodTypes.splice(index, 1);
  },
  updateNormPeriodTypes(state: INormPeriodTypeState, normPeriodTypes: NormPeriodType[]) {
    state.normPeriodTypes = [
      ...state.normPeriodTypes,
      ...normPeriodTypes.filter(
        (newNormPeriod) => !state.normPeriodTypes.find((existing) => existing.equals(newNormPeriod))
      )
    ];
  }
};

export const normPeriodStoreModule: Module<INormPeriodTypeState, IIDAStore> = {
  namespaced: namespaced,
  state: getInitialState(),
  getters: getters,
  actions: actions,
  mutations: mutations
};
